import React from 'react';
import Collapsible from 'react-collapsible';
import styled from 'styled-components';
import ArrowDown from '../assets/arrowDown.svg';
import ArrowUp from '../assets/arrowUp.svg';
import breakpoint from 'styled-components-breakpoint';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

const Wrapper = styled.div`
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 30px;
    ${breakpoint('tablet')`
      margin-bottom: 40px;
  `};
  }

  & .Collapsible__trigger > div {
    background-image: url(${ArrowDown});
  }
  & .Collapsible__trigger.is-open > div {
    background-image: url(${ArrowUp});
    color: #3970e5;
  }
`;

const CollapsableBar = styled.div`
  box-sizing: border-box;
  padding: 16px 20px;
  padding-right: 50px;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 1000px;
  max-width: calc(100vw - 40px);
  background-color: #ffffff;
  box-shadow: 0 3px 22px 0 rgba(0, 0, 0, 0.04);

  color: #686868;
  font-size: 15px;
  line-height: 17px;

  background-position: right 20px center;
  background-repeat: no-repeat;
`;

const CollapsibleText = styled.div`
  box-sizing: border-box;
  padding: 16px 20px;
  width: 1000px;
  max-width: calc(100vw - 40px);
  background-color: #ffffff;
  box-shadow: 0 3px 22px 0 rgba(0, 0, 0, 0.04);
  color: #686868;
  font-size: 15px;
  line-height: 17px;
`;

const Accordion = ({ title, text }) => {
  return (
    <Wrapper>
      <Collapsible
        trigger={
          <CollapsableBar>
            <strong>{title}</strong>
          </CollapsableBar>
        }
        open={false}
        easing="ease"
      >
        <CollapsibleText>{text}</CollapsibleText>
      </Collapsible>
    </Wrapper>
  );
};

const AccordionWrapper = () => {
  return (
    <React.Fragment>
      <Accordion
        title={
          <FormattedMessage
            id="shop.accordion.first.title"
            defaultMessage="Можно ли купить у вас домен?"
          />
        }
        text={
          <FormattedHTMLMessage
            id="shop.accordion.first"
            defaultMessage="Нет, мы не занимаемся продажей доменов. Вы можете перейти на сайт <a href='https://nic.md/ro/domain/' target='_blank'>https://nic.md/ro/domain/</a> и зарегистрировать домен."
          />
        }
      />
      <Accordion
        title={
          <FormattedMessage
            id="shop.accordion.second.title"
            defaultMessage="Есть ли ограничение в добавлении информации?"
          />
        }
        text={
          <FormattedMessage
            id="shop.accordion.second"
            defaultMessage="Ограничений в добавлении товара нет. Хостинг включен в ежемесячную плату и неограничен по объёму."
          />
        }
      />
      <Accordion
        title={
          <FormattedMessage
            id="shop.accordion.third.title"
            defaultMessage="Можно ли сменить тариф?"
          />
        }
        text={
          <FormattedMessage
            id="shop.accordion.third"
            defaultMessage="Смена тарифа возможна в случае перехода с низкого на высокий тариф (Lite to Standart) в любой момент. Переход с высокого тарифа на низкий (Standart to Lite) возможен по истечении первого года использования контракта. При любом переходе необходимо пере подписать контракт."
          />
        }
      />
      <Accordion
        title={
          <FormattedMessage
            id="shop.accordion.fourth.title"
            defaultMessage="Как подключить аналитику на сайте?"
          />
        }
        text={
          <FormattedHTMLMessage
            id="shop.accordion.fourth"
            defaultMessage="Для того, чтобы подключить аналитику на сайте, Вы самостоятельно проходите регистрацию на ресурсах: <a href='https://analytics.google.com/analytics/web/provision/#/provision' target='_blank'>GA</a>, <a href='https://support.google.com/analytics/answer/9304153?hl=en' target='_blank'>GA-4</a>, <a href='https://tagmanager.google.com/#/home' target='_blank'>GTM</a>, <a href='https://metrika.yandex.ru/list' target='_blank'>YM</a>, <a href='https://search.google.com/search-console/welcome' target='_blank'>GSC</a>. После регистрации Вы получите код, который необходимо будет сохранить в настройках Вашего кабинета."
          />
        }
      />
      <Accordion
        title={
          <FormattedMessage
            id="shop.accordion.fifth.title"
            defaultMessage="Сколько времени необходимо для создания сайта под ключ?"
          />
        }
        text={
          <FormattedMessage
            id="shop.accordion.fifth"
            defaultMessage="Срок, как и цена, зависит от сложности проекта и используемых решений. В среднем на разработку сайтов, типа сайт визитка, несложный портал предприятия, портфолио, простой интернет-магазин необходимо от одной недели до трех. На реализацию крупных индивидуальных проектов требуется больше времени. *Стоит заметить, что часть времени уходит не на программирование, а на ожидание обратной связи от заказчика, утверждение или ожидание материалов."
          />
        }
      />
      <Accordion
        title={
          <FormattedMessage
            id="shop.accordion.sixth.title"
            defaultMessage="Риски и какие гарантии мы даем?"
          />
        }
        text={
          <FormattedMessage
            id="shop.accordion.sixth"
            defaultMessage="999 Business (в прошлом shop.price.md) проект компании Simpals запущенный в 2015 году. За это время мы реализовали множество не только интернет-магазинов под ключ, сайтов визиток, но и немало индивидуальных решений. Кроме отзывов, есть вариант зайти на любой сайт из нашего портфолио и пообщаться с владельцами сайтов о сотрудничестве с проектом 999 Business. Главной гарантией нашей надежности и Вашей безопасности, несомненно, является договор. В договоре разработки сайта указаны требования, а также права и обязанности обеих сторон — заказчика и подрядчика."
          />
        }
      />
    </React.Fragment>
  );
};

export default AccordionWrapper;



// WEBPACK FOOTER //
// ./src/routes/Shop/blocks/accordion.js